import { motion } from 'framer-motion';
import styled from 'styled-components';

import { floorGameCardVariants } from './FloorGameCard.motion';

export const StyledFloorGameCard = styled(motion.div).attrs({
    variants: floorGameCardVariants,
})`
    display: grid;
`;
